<template>
  <div :class="{ 'chat-is-open': isChatOpen }" class="cierra-chat-widget ctw-absolute ctw-bottom-0 ctw-right-0" style="z-index: 999999;">
    <ChatBubble v-if="!isLoading"/>
    <ChatWindow v-if="!isLoading" />
  </div>
</template>

<script setup>
import { computed, defineProps } from 'vue';
import ChatBubble from './ChatBubble.vue';
import ChatWindow from './ChatWindow.vue';
import {useWidgetStore} from '../store/widget.js';
import {useConversationStore} from '../store/conversation.js';


const props = defineProps(['token', 'botId']);

const widgetStore = useWidgetStore();
const conversationStore = useConversationStore();

widgetStore.loadBot(props.botId, props.token).then(() => {
    if(conversationStore.conversationId) {
        conversationStore.loadConversation(conversationStore.conversationId);
    }
});

const isLoading = computed(() => widgetStore.isLoading);
const isChatOpen = computed(() => widgetStore.isChatOpen);
const shouldShowTeaserMessage = computed(() => widgetStore.shouldShowTeaserMessage);


setTimeout(() => {
    if(!shouldShowTeaserMessage.value) {
        return;
    }
    widgetStore.setTeaserMessageOpen(true);
}, 500);


widgetStore.handleCommonOverlayIssues();

//add event listerner to window for function askAIBot('question?')
window.addEventListener('askAIBot', (e) => {
   widgetStore.toggleChat();
   conversationStore.sendMessage(e.detail);
});

</script>

<style>
/* Hide chat-bubble when screen is less than 768px and chat is open */
@media screen and (max-width: 768px) {
  .chat-is-open .chat-bubble {
    display: none;
  }
}
</style>